import 'css-chunksrc/client/common/projectSection/project/styles.scss';export default {
  "project": "_project_1510o_1",
  "container": "_container_1510o_6",
  "row": "_row_1510o_15",
  "contextualMenu": "_contextualMenu_1510o_23",
  "projectPopup": "_projectPopup_1510o_26",
  "popupIcon": "_popupIcon_1510o_36",
  "projectPopupMain": "_projectPopupMain_1510o_42",
  "addMargin": "_addMargin_1510o_56",
  "dates": "_dates_1510o_60",
  "date": "_date_1510o_60",
  "status": "_status_1510o_73",
  "tags": "_tags_1510o_80",
  "icon": "_icon_1510o_87",
  "link": "_link_1510o_95",
  "name": "_name_1510o_99",
  "createProjectStrategicAxis": "_createProjectStrategicAxis_1510o_112",
  "weather": "_weather_1510o_116",
  "weatherIcon": "_weatherIcon_1510o_123",
  "avatar": "_avatar_1510o_128",
  "activityMonitoring": "_activityMonitoring_1510o_143",
  "workload": "_workload_1510o_144",
  "budget": "_budget_1510o_145",
  "text": "_text_1510o_164",
  "positive": "_positive_1510o_168",
  "warning": "_warning_1510o_172",
  "opened": "_opened_1510o_176",
  "col": "_col_1510o_180",
  "budget_allocatedBudget": "_budget_allocatedBudget_1510o_185",
  "budget_plannedBudget": "_budget_plannedBudget_1510o_185",
  "budget_realCosts": "_budget_realCosts_1510o_185",
  "budget_plannedMargin": "_budget_plannedMargin_1510o_185",
  "budget_realMargin": "_budget_realMargin_1510o_185",
  "budget_acquiredValue": "_budget_acquiredValue_1510o_185",
  "workload_allocatedTime": "_workload_allocatedTime_1510o_185",
  "workload_spentTime": "_workload_spentTime_1510o_185",
  "workload_remainingWork": "_workload_remainingWork_1510o_185",
  "activityMonitoring_done": "_activityMonitoring_done_1510o_185",
  "activityMonitoring_delayed": "_activityMonitoring_delayed_1510o_185",
  "activityMonitoring_opened": "_activityMonitoring_opened_1510o_185",
  "criteriaCol": "_criteriaCol_1510o_192",
  "infoBubble": "_infoBubble_1510o_196",
  "zone": "_zone_1510o_211",
  "slideIn": "_slideIn_1510o_1"
};